"use strict";var e=require("../Coerce/enumeration.cjs").enumeration(["ANDROID","CHROMEOS","HBBTV","IOS","LINUX","OSX","TIZEN","UNKNOWN","VIDAA","VIERA","WEBMAF","WEBOS","WINDOWS"]);exports.OperatingSystemId=e;
//# sourceMappingURL=OperatingSystemId.cjs.map
